import { AppCtaButtons, Link as ExternalLink } from "components";
import { Link } from "react-router-dom";

export default function Download() {
  return (
    <section className="w-full space-y-2.5 mt-7 lg:mt-10 mx-auto max-w-[28rem] lg:max-w-none">
      <p className="w-full text-sm lg:text-base text-[#626369] text-center font-normal">
        Download the latest version of LinksRoom for a better experience:
      </p>
      <AppCtaButtons />
      <ul className="w-full flex items-center justify-center text-sm text-[#626369] text-center font-normal gap-2.5 py-2.5 mx-auto">
        <li className="underline underline-offset-2">
          <Link to="/terms" target="_blank">
            Terms of use
          </Link>
        </li>
        <li className="text-center">
          <span className="block size-[3px] bg-[#9A9EB1] rounded-full mx-auto" />
        </li>
        <li className="underline underline-offset-2">
          <Link to="/privacy" target="_blank">
            Privacy Policy
          </Link>
        </li>
        <li className="text-center">
          <span className="block size-[3px] bg-[#9A9EB1] rounded-full mx-auto" />
        </li>
        <li className="underline underline-offset-2">
          <ExternalLink href="mailto:gataastudio@gmail.com">
            Contact us
          </ExternalLink>
        </li>
      </ul>
    </section>
  );
}
